import { useState, useEffect } from 'react';
import {
  Divider,
  Container,
  Grid,
  TextField,
  Button,
  Typography,
  createTheme,
  Box,
  Link,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import AppAppBar2 from '../components/AppBar2';
import ProductHeroLayout from '../components/ProductHeroLayout';
import { palette } from '@mui/system';
import { useFetchNoUser } from '../hooks/useFetchNoUser';
import CircularProgress from '@mui/material/CircularProgress';
import SelectNationality from '../components/SelectNationality';
import { NatOutlined } from '@mui/icons-material';
import validator from 'validator';
import SelectTitle from '../components/SelectTitle';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SelectRace from '../components/SelectRace';
import SelectSALang from '../components/SelectSALang';
import EnterIDPass from '../components/EnterIDPass';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import SelectPreviousGrade from '../components/SelectPreviousGrade';
export default function RegisterUser() {
  const [backgroundImage, setBackgroundImage] = useState('../img/Student3.jpg');
  const [ipAddress, setIPAddress] = useState('');

  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => setIPAddress(data.ip))
      .then(console.log('My ip address is ' + ipAddress))
      .catch((error) => console.log(error));
  }, [ipAddress]);

  const {
    postData: checkuserbyidentity,
    error,
    errorMessage,
    data: userValid,
    isPending,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/checkexistinguser/byidentity',
    'POST',
  );

  //existing student
  const {
    postData: checkstudentbyidentity,
    error: error2,
    errorMessage: errorMessage2,
    data: studentCount,
    isPending: isPending2,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/checkexistingstudent/byidentity',
    'POST',
  );
  const {
    postData: emailExistingOtp,
    error: error3,
    errorMessage: errorMessage3,
    data: existingOTPSent,
    isPending: isPending3,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/existingstudent/sendotp',
    'POST',
  );
  const {
    postData: verifyExistingOTP,
    error: error4,
    errorMessage: errorMessage4,
    data: existingOTPVerified,
    isPending: isPending4,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/existingstudent/verifyotp',
    'POST',
  );

  const {
    postData: acceptExisting,
    error: error6,
    errorMessage: errorMessage6,
    data: existingTermsAccepted,
    isPending: isPending6,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/existingstudent/acceptterms',
    'POST',
  );
  const {
    postData: submitExistingPass,
    error: error5,
    errorMessage: errorMessage5,
    data: userExistingCreated,
    isPending: isPending5,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/existingstudent/create',
    'POST',
  );

  //new setudent
  const {
    postData: checkNewEmail,
    error: error7,
    errorMessage: errorMessage7,
    data: emailValid,
    isPending: isPending7,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/newuser/checkexistingemail',
    'POST',
  );

  const {
    postData: sendNewOTP,
    error: error8,
    errorMessage: errorMessage8,
    data: newOTPSent,
    isPending: isPending8,
  } = useFetchNoUser('https://pcapi.bi-oss.co.za/user/newuser/sendotp', 'POST');

  const {
    postData: verifyNewOTP,
    error: error9,
    errorMessage: errorMessage9,
    data: newOtpVerified,
    isPending: isPending9,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/newuser/verifyotp',
    'POST',
  );

  const {
    postData: acceptNewTerms,
    error: error10,
    errorMessage: errorMessage10,
    data: newTermsAccepted,
    isPending: isPending10,
  } = useFetchNoUser(
    'https://pcapi.bi-oss.co.za/user/newuser/acceptterms',
    'POST',
  );

  const {
    postData: createNewUser,
    error: error11,
    errorMessage: errorMessage11,
    data: newUserCreated,
    isPending: isPending11,
  } = useFetchNoUser('https://pcapi.bi-oss.co.za/user/newuser/create', 'POST');

  const navigate = useNavigate();
  const [succ, setSucc] = useState('');
  const [conf1, setConf1] = useState(false);
  const [conf2, setConf2] = useState(false);
  const [conf3, setConf3] = useState(false);
  const [createNew, setCreateNew] = useState(0);
  const [existingStudent, setExistingStudent] = useState(0);
  const [viewTerms, setViewTerms] = useState(0);
  const [viewDecline, setViewDecline] = useState(0);
  const [password, setPassword] = useState('');
  const [otp, setOTP] = useState('');
  const [otpMessage, setOTPMessage] = useState('');
  const [otpSent, setOTPSent] = useState(0);
  const [idpass, setIdPass] = useState('');
  const [viewEmailError, setViewEmailError] = useState(0);

  const [nation, setNation] = useState('South African');
  const [resend, setResend] = useState(0);
  const [enterPass, setEnterPass] = useState(0);
  const [errorPass, setErrorPass] = useState('');
  const [successPass, setSuccessPass] = useState('');

  const [email, setEmail] = useState('');
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [dob, setDob] = useState('');
  const [gender, setGender] = useState('');
  const [raceId, setRaceId] = useState('');
  const [saMobile, setSaMobile] = useState('');
  const [languageId, setLanguageId] = useState('');
  const [school, setSchool] = useState('');
  const [grade, setGrade] = useState('');
  const validate = (value) => {
    if (
      validator.isStrongPassword(value, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      setErrorPass('');
      setSuccessPass('Password strength: Secure.');
      setPassword(value);
    } else {
      setSuccessPass('');
      setErrorPass('Password strength: Weak.');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    checkuserbyidentity({ idpass });
  };

  useEffect(() => {
    if (userValid) {
      checkstudentbyidentity({ idpass });
    }
  }, [userValid]);

  useEffect(() => {
    if (studentCount) {
      if (studentCount.studentCount === 0) {
        setExistingStudent(0);
        setCreateNew(1);
      }
      if (studentCount.studentCount > 0) {
        setCreateNew(0);
        setExistingStudent(1);
      }
    }
  }, [studentCount]);

  //existing user functions
  const handleSubmit2 = (e) => {
    e.preventDefault();
    emailExistingOtp({ idpass, email });
  };

  useEffect(() => {
    if (existingOTPSent) {
      setOTPMessage(existingOTPSent.message);
      setOTPSent(1);
    }
  }, [existingOTPSent]);

  const handleSubmit3 = (e) => {
    e.preventDefault();
    verifyExistingOTP({
      idpass,
      otp,
    });
  };
  const resendOTP = (e) => {
    emailExistingOtp({ idpass });
    setResend(1);
  };

  useEffect(() => {
    if (existingOTPVerified) {
      setOTPSent(0);

      setViewTerms(1);
    }
  }, [existingOTPVerified]);

  const handleAcceptExisting = (e) => {
    e.preventDefault();
    acceptExisting({ idpass, ipAddress });
  };

  const handleDecline = (e) => {
    setViewTerms(0);
    setViewDecline(1);
    setCreateNew(0);
    setExistingStudent(0);
  };

  const handleSubmit4 = (e) => {
    e.preventDefault();
    submitExistingPass({ idpass, password });
  };

  useEffect(() => {
    if (existingTermsAccepted) {
      setViewTerms(0);
      setEnterPass(1);
    }
  }, [existingTermsAccepted]);

  useEffect(() => {
    if (userExistingCreated) {
      setSucc(1);
    }
  }, [userExistingCreated]);

  const handleSubmit5 = (e) => {
    e.preventDefault();
    checkNewEmail({ email });
  };

  useEffect(() => {
    if (errorMessage7) {
      setViewEmailError(1);
    }
  }, [errorMessage7]);

  useEffect(() => {
    if (emailValid) {
      sendNewOTP({
        fname,
        lname,
        email,
        dob,
      });
    }
  }, [emailValid]);

  const resendNewOTP = (e) => {
    e.preventDefault();
    sendNewOTP({
      fname,
      lname,
      email,
      dob,
    });
  };
  const resendNewOTP2 = (e) => {
    setResend(1);
    sendNewOTP({
      fname,
      lname,
      email,
      dob,
    });
  };

  useEffect(() => {
    if (newOTPSent) {
      setOTPSent(1);
    }
  }, [newOTPSent]);

  const handleSubmit6 = (e) => {
    e.preventDefault();
    verifyNewOTP({ otp, dob });
  };

  useEffect(() => {
    if (newOtpVerified) {
      setOTPSent(0);
      setViewTerms(1);
    }
  }, [newOtpVerified]);

  const handleSubmit7 = (e) => {
    e.preventDefault();

    acceptNewTerms({ idpass, email, ipAddress });
  };

  useEffect(() => {
    if (newTermsAccepted) {
      setViewTerms(0);
      setEnterPass(1);
    }
  }, [newTermsAccepted]);
  const handleSubmit8 = (e) => {
    e.preventDefault();

    createNewUser({
      nation,
      idpass,
      email,
      fname,
      lname,
      saMobile,
      dob,
      gender,
      raceId,
      languageId,
      school,
      grade,
      password,
    });
  };

  useEffect(() => {
    if (newUserCreated) {
      setSucc(1);
    }
  }, [newUserCreated]);

  return (
    <>
      <AppAppBar2 />
      <ProductHeroLayout
        fullWidth
        sxBackground={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundColor: '#7fc7d9', // Average color of the background image.
          fullWidth: '90vh',
          transition: 'background 3s linear',
        }}
      >
        <Box mb={5} />

        {!existingStudent && !createNew && !succ && !viewDecline && (
          <>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Container
                maxWidth="md"
                disableGutters
                align="center"
                sx={{
                  overflow: 'scroll',
                  maxHeight: '90vh',
                  backgroundColor: 'white',
                  opacity: '0.8',
                  border: 'Solid',
                  borderWidth: '5px',
                  borderColor: 'primary.main',
                  padding: '10px',
                  borderRadius: 3,
                  marginTop: 1,
                }}
              >
                <form onSubmit={handleSubmit}>
                  <Box mb={5} />
                  <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                  >
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        f
                        alignItems="center"
                        textAlign="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Typography
                          variant="h3"
                          color="textSecondary"
                          component="h3"
                          gutterBottom
                        >
                          Register
                        </Typography>
                      </Box>
                    </Grid>

                    {!isPending && !isPending2 && !errorMessage && (
                      <>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              fontFamily={'Arial'}
                            >
                              To create an account, candidates must select their
                              nationality and enter their identification
                              information below.
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              If you are an existing BIC student without a
                              Private Candidate portal login, simply enter your
                              details as supplied during your registration and
                              follow the prompts below.
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h6"
                              color="textSecondary"
                              component="h6"
                              fontFamily={'Arial'}
                            >
                              <b>Please note the following:</b>
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            textAlign="left"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              fontFamily={'Arial'}
                            >
                              <ul>
                                <li>
                                  South African Citizens must use their RSA
                                  Identification Number or RSA Birth Certificate
                                  Number.
                                </li>
                                <li>
                                  International students may use their
                                  international passport number; however, these
                                  students will be required to prove eligibility
                                  to study within South Africa prior to writing
                                  examinations.
                                </li>
                                <li>
                                  Candidates will be required to produce their
                                  original or certified copy of identification
                                  prior to writing <b>each</b> examination paper
                                  or when collecting transcripts. Candidates
                                  without identification may be denied entry
                                  into the examination venue.
                                </li>
                              </ul>
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            f
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <SelectNationality
                              nation={nation}
                              setNation={setNation}
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            f
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <EnterIDPass
                              nation={nation}
                              setIdPass={setIdPass}
                              idpass={idpass}
                            />
                          </Box>
                        </Grid>
                      </>
                    )}

                    <Box mb={2} />
                    {error && !errorMessage && (
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          textAlign="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <p className="error">
                            Service currently offline. Please try again later.
                          </p>
                        </Box>
                      </Grid>
                    )}
                    {errorMessage && (
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          textAlign="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <p className="error">{errorMessage}</p>
                        </Box>
                      </Grid>
                    )}

                    {!isPending && !isPending2 && !errorMessage && (
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          textAlign="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button
                                variant="contained"
                                type="submit"
                                fullWidth
                              >
                                Continue
                              </Button>
                            </Box>
                          </Grid>
                        </Box>
                      </Grid>
                    )}
                    {!isPending && !isPending2 && errorMessage && (
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          textAlign="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button
                                variant="contained"
                                onClick={(e) => window.location.reload()}
                                fullWidth
                              >
                                Back
                              </Button>
                            </Box>
                          </Grid>
                        </Box>
                      </Grid>
                    )}
                    {(isPending || isPending2) && (
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          textAlign="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Button variant="contained" disabled fullWidth>
                            <CircularProgress />
                          </Button>
                        </Box>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Link href="../login">Login</Link>
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Link href="../forgotpassword">
                              Forgot Password?
                            </Link>
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>

                    <Box mb={2} />
                  </Grid>
                </form>
              </Container>
            </Box>
          </>
        )}

        {existingStudent > 0 && !succ && !viewDecline && (
          <>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box mb={5} />
              {!otpSent && !viewTerms && !enterPass && (
                <>
                  <Container
                    maxWidth="md"
                    disableGutters
                    align="center"
                    top="50%"
                    sx={{
                      overflow: 'scroll',
                      maxHeight: '90vh',
                      backgroundColor: 'white',
                      opacity: '0.8',
                      border: 'Solid',
                      borderWidth: '5px',
                      borderColor: 'primary.main',
                      padding: '30px',
                      borderRadius: 3,
                      marginTop: 3,
                    }}
                  >
                    <form onSubmit={handleSubmit2}>
                      <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                      >
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            f
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h4"
                              color="textSecondary"
                              component="h4"
                              gutterBottom
                            >
                              Existing Student Profile
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            f
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="textSecondary"
                              component="h5"
                              gutterBottom
                            >
                              Verification Step 1/2:
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            f
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              A student or candidate profile matching this
                              identification information has been found. To
                              verify this is you, please enter the
                              student/candidate email address assocaited with
                              this account.
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            f
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <TextField
                                  id="emailbox"
                                  label="Candidate/Student Email Address:"
                                  variant="outlined"
                                  type="email"
                                  required
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  fullWidth
                                  autoComplete="email"
                                  autoFocus
                                  inputProps={{
                                    style: { textAlign: 'center' },
                                  }}
                                />
                              </Box>
                            </Grid>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            f
                            alignItems="center"
                            textAlign="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            {error3 && !errorMessage3 && (
                              <p className="error">
                                Service currently offline. Please try again
                                later.
                              </p>
                            )}
                            {errorMessage3 && (
                              <p className="error">{errorMessage3}</p>
                            )}
                          </Box>
                        </Grid>

                        {!isPending3 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              f
                              alignItems="center"
                              textAlign="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    type="submit"
                                    fullWidth
                                  >
                                    Send OTP
                                  </Button>
                                </Box>
                              </Grid>
                            </Box>
                          </Grid>
                        )}

                        {isPending3 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              f
                              alignItems="center"
                              textAlign="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    disabled
                                    fullWidth
                                  >
                                    <CircularProgress />
                                  </Button>
                                </Box>
                              </Grid>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </form>
                  </Container>
                </>
              )}

              {otpSent > 0 && !enterPass && !viewTerms && (
                <Container
                  maxWidth="md"
                  disableGutters
                  align="center"
                  top="50%"
                  sx={{
                    overflow: 'scroll',
                    maxHeight: '90vh',
                    backgroundColor: 'white',
                    opacity: '0.8',
                    border: 'Solid',
                    borderWidth: '5px',
                    borderColor: 'primary.main',
                    padding: '30px',
                    borderRadius: 3,
                    marginTop: 3,
                  }}
                >
                  <form onSubmit={handleSubmit3}>
                    <Grid
                      container
                      spacing={{ xs: 2, md: 3 }}
                      columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                    >
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="h4"
                            color="textSecondary"
                            component="h4"
                            gutterBottom
                          >
                            Existing Candidate Profile
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="h5"
                            color="textSecondary"
                            component="h5"
                            gutterBottom
                          >
                            Verification Step 2/2:
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="paragraph"
                            color="textSecondary"
                            component="p"
                            gutterBottom
                            fontFamily={'Arial'}
                          >
                            {otpMessage}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="paragraph"
                            color="textSecondary"
                            component="p"
                            gutterBottom
                            fontFamily={'Arial'}
                          >
                            Please enter the OTP below to verify your account.
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <TextField
                                id="otp"
                                label="Enter OTP:"
                                variant="outlined"
                                type="numbers"
                                required
                                onChange={(e) => setOTP(e.target.value)}
                                value={otp}
                                fullWidth
                                autoFocus
                                inputProps={{ style: { textAlign: 'center' } }}
                              />
                            </Box>
                          </Grid>
                        </Box>
                      </Grid>

                      {error4 && !errorMessage4 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <p className="error">
                              Service currently offline. Please try again later.
                            </p>
                          </Box>
                        </Grid>
                      )}
                      {errorMessage4 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <p className="error">{errorMessage4}</p>
                          </Box>
                        </Grid>
                      )}

                      {!isPending4 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button
                                  variant="contained"
                                  type="submit"
                                  fullWidth
                                >
                                  Submit OTP
                                </Button>
                              </Box>
                            </Grid>
                          </Box>
                        </Grid>
                      )}

                      {isPending4 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button variant="contained" disabled fullWidth>
                                  <CircularProgress />
                                </Button>
                              </Box>
                            </Grid>
                          </Box>
                        </Grid>
                      )}

                      {!resend && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              OR
                            </Typography>
                          </Box>
                        </Grid>
                      )}

                      {(!isPending3 || !isPending4) && !resend && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button
                                  variant="contained"
                                  onClick={(e) => resendOTP()}
                                  fullWidth
                                >
                                  Resend OTP
                                </Button>
                              </Box>
                            </Grid>
                          </Box>
                        </Grid>
                      )}
                      {resend === 1 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              OTP resent via email
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </form>
                </Container>
              )}

              {viewTerms === 1 && (
                <>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Container
                      maxWidth="md"
                      disableGutters
                      align="center"
                      top="50%"
                      sx={{
                        overflow: 'scroll',
                        maxHeight: '90vh',
                        backgroundColor: 'white',
                        opacity: '0.8',
                        border: 'Solid',
                        borderWidth: '5px',
                        borderColor: 'primary.main',
                        padding: '30px',
                        borderRadius: 3,
                        marginTop: 3,
                      }}
                    >
                      <form onSubmit={handleAcceptExisting}>
                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                        >
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="h4"
                                color="textSecondary"
                                component="h4"
                                gutterBottom
                              >
                                Terms and Conditions
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="h5"
                                color="textSecondary"
                                component="h5"
                                gutterBottom
                              >
                                Agreement 1:
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                To view our Terms and Conditions, visit:
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                <a
                                  href="https://privatecandidate.bi-oss.co.za/tnc"
                                  target="blank"
                                >
                                  https://privatecandidate.bi-oss.co.za/tnc
                                </a>
                                .
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                By clicking agree, I state that I have read,
                                understood and agree to all the "Terms and
                                Conditions" in the above link.
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={12}
                                sx={{
                                  textAlign: 'center',
                                  alignContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <Typography sx={{ textAlign: 'left' }}>
                                  I <u>Decline</u>{' '}
                                </Typography>
                                {conf1 === false && (
                                  <>
                                    <Switch
                                      checked={false}
                                      required
                                      inputProps={{
                                        'aria-label': 'ant design',
                                      }}
                                      onChange={(e) => setConf1(true)}
                                      name="I Decline"
                                    />
                                  </>
                                )}
                                {conf1 === true && (
                                  <>
                                    <Switch
                                      sx={{ textAlign: 'center' }}
                                      color="success"
                                      checked={true}
                                      required
                                      inputProps={{
                                        'aria-label': 'ant design',
                                      }}
                                      onChange={(e) => setConf1(false)}
                                      name="I Agree"
                                    />
                                  </>
                                )}

                                <Typography sx={{ textAlign: 'right' }}>
                                  I <u>Agree</u>{' '}
                                </Typography>
                              </Stack>
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Divider
                                style={{ width: '100%', color: 'primary.main' }}
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="h5"
                                color="textSecondary"
                                component="h5"
                                gutterBottom
                              >
                                Agreement 2:
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                To view the Code of Conduct visit:
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                <a
                                  href="https://privatecandidate.bi-oss.co.za/conduct"
                                  target="blank"
                                >
                                  https://privatecandidate.bi-oss.co.za/conduct
                                </a>
                                .
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                By clicking agree, I state that I have read,
                                understood and agree to the "Code of Conduct" in
                                the above link.
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={12}
                                sx={{
                                  textAlign: 'center',
                                  alignContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <Typography sx={{ textAlign: 'left' }}>
                                  I <u>Decline</u>{' '}
                                </Typography>
                                {conf2 === false && (
                                  <>
                                    <Switch
                                      checked={false}
                                      required
                                      inputProps={{
                                        'aria-label': 'ant design',
                                      }}
                                      onChange={(e) => setConf2(true)}
                                      name="I Decline"
                                    />
                                  </>
                                )}
                                {conf2 === true && (
                                  <>
                                    <Switch
                                      sx={{ textAlign: 'center' }}
                                      color="success"
                                      checked={true}
                                      required
                                      inputProps={{
                                        'aria-label': 'ant design',
                                      }}
                                      onChange={(e) => setConf2(false)}
                                      name="I Agree"
                                    />
                                  </>
                                )}

                                <Typography sx={{ textAlign: 'right' }}>
                                  I <u>Agree</u>{' '}
                                </Typography>
                              </Stack>
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Divider
                                style={{ width: '100%', color: 'primary.main' }}
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="h5"
                                color="textSecondary"
                                component="h5"
                                gutterBottom
                              >
                                Agreement 3:
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                To view the Cambridge International Examination
                                Rules and Regulations:
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                <a
                                  href="https://privatecandidate.bi-oss.co.za/cierules"
                                  target="blank"
                                >
                                  https://privatecandidate.bi-oss.co.za/cierules
                                </a>
                                .
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="body2"
                                component="p"
                                color="primary.main"
                                sx={{ textAlign: 'center' }}
                              >
                                By clicking agree, I state that I have read,
                                understood and agree to all the "Cambridge
                                International Examination Rules and Regulations"
                                in the above link.
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={12}
                                sx={{
                                  textAlign: 'center',
                                  alignContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                <Typography sx={{ textAlign: 'left' }}>
                                  I <u>Decline</u>{' '}
                                </Typography>
                                {conf3 === false && (
                                  <>
                                    <Switch
                                      checked={false}
                                      required
                                      inputProps={{
                                        'aria-label': 'ant design',
                                      }}
                                      onChange={(e) => setConf3(true)}
                                      name="I Decline"
                                    />
                                  </>
                                )}
                                {conf3 === true && (
                                  <>
                                    <Switch
                                      sx={{ textAlign: 'center' }}
                                      color="success"
                                      checked={true}
                                      required
                                      inputProps={{
                                        'aria-label': 'ant design',
                                      }}
                                      onChange={(e) => setConf3(false)}
                                      name="I Agree"
                                    />
                                  </>
                                )}

                                <Typography sx={{ textAlign: 'right' }}>
                                  I <u>Agree</u>{' '}
                                </Typography>
                              </Stack>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Divider
                                style={{ width: '100%', color: 'primary.main' }}
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography sx={{ textAlign: 'center' }}>
                                *{' '}
                                <i>
                                  <b>Please Note: </b>The above "Cambridge
                                  International Examination Rules and
                                  Regulations", "Code of Conduct", "Terms and
                                  Conditions" are all subject to change.
                                </i>{' '}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              {error6 && !errorMessage6 && (
                                <p className="error">
                                  Service currently offline. Please try again
                                  later.
                                </p>
                              )}
                              {errorMessage6 && (
                                <p className="error">{errorMessage6}</p>
                              )}
                            </Box>
                          </Grid>

                          {!isPending6 && (
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button
                                  variant="contained"
                                  type="submit"
                                  fullWidth
                                >
                                  Accept
                                </Button>
                              </Box>
                            </Grid>
                          )}

                          {isPending6 && (
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button variant="contained" disabled fullWidth>
                                  <CircularProgress />
                                </Button>
                              </Box>
                            </Grid>
                          )}
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="h5"
                                color="textSecondary"
                                component="h5"
                                gutterBottom
                              >
                                OR
                              </Typography>
                            </Box>
                          </Grid>

                          {!isPending6 && (
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button
                                  variant="contained"
                                  onClick={(e) => handleDecline()}
                                  fullWidth
                                >
                                  Decline
                                </Button>
                              </Box>
                            </Grid>
                          )}
                        </Grid>

                        <Box mb={5} />
                      </form>
                    </Container>
                  </Box>
                </>
              )}
              {enterPass > 0 && (
                <>
                  <Container
                    maxWidth="xs"
                    disableGutters
                    align="center"
                    top="50%"
                    sx={{
                      maxHeight: '90vh',
                      backgroundColor: 'white',
                      opacity: '0.8',
                      border: 'Solid',
                      borderWidth: '5px',
                      borderColor: 'primary.main',
                      padding: '30px',
                      borderRadius: 3,
                      marginTop: 3,
                    }}
                  >
                    <form onSubmit={handleSubmit4}>
                      <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                      >
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h4"
                              color="textSecondary"
                              component="h4"
                              gutterBottom
                            >
                              Existing Student/Candidate
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="textSecondary"
                              component="h5"
                              gutterBottom
                            >
                              Create Account
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              Please enter a password for your account.
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              Password minimum requirements:
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                              textAlign="left"
                            >
                              <ul>
                                <li>Minimum of 8 character</li>
                                <li>1 Uppercase character</li>
                                <li>1 Lowercase character</li>
                                <li>1 Numeric Character (Number)</li>
                                <li>1 Symbol (special character)</li>
                              </ul>
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <TextField
                              id="password"
                              label="Enter New Password"
                              onChange={(e) => validate(e.target.value)}
                              fullWidth
                              required
                              type="password"
                              autoComplete="nope"
                              inputProps={{
                                maxLength: 100,
                                minLength: 8,
                                style: { textAlign: 'center' },
                              }}
                            />
                          </Box>
                        </Grid>

                        {errorPass && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <p className="error">{errorPass}</p>
                            </Box>
                          </Grid>
                        )}
                        {successPass && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <TextField
                                id="Notification"
                                InputProps={{
                                  readOnly: true,
                                }}
                                value={successPass}
                                fullWidth
                                required
                                sx={{
                                  borderRadius: 1,
                                  backgroundColor: 'success.main',
                                  input: {
                                    color: 'white',
                                    textAlign: 'center',
                                  },
                                }}
                              />
                            </Box>
                          </Grid>
                        )}

                        {error5 && !errorMessage5 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <p className="error">
                                Service currently offline. Please try again
                                later.
                              </p>
                            </Box>
                          </Grid>
                        )}
                        {errorMessage5 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <p className="error">{errorMessage5}</p>
                            </Box>
                          </Grid>
                        )}

                        {!isPending5 && !errorPass && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button
                                variant="contained"
                                type="submit"
                                fullWidth
                              >
                                Create Account
                              </Button>
                            </Box>
                          </Grid>
                        )}
                        {errorPass && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button variant="contained" disabled fullWidth>
                                Create Account
                              </Button>
                            </Box>
                          </Grid>
                        )}
                        {isPending5 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button variant="contained" disabled fullWidth>
                                <CircularProgress />
                              </Button>
                            </Box>
                          </Grid>
                        )}
                      </Grid>

                      <Box mb={5} />
                    </form>
                  </Container>
                </>
              )}
            </Box>
          </>
        )}
        {viewDecline === 1 && (
          <>
            <Container
              maxWidth="md"
              disableGutters
              align="center"
              top="0"
              sx={{
                maxHeight: '90vh',
                backgroundColor: 'white',
                opacity: '0.8',
                border: 'Solid',
                borderWidth: '5px',
                borderColor: 'primary.main',
                padding: '30px',
                borderRadius: 3,
              }}
            >
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              >
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    f
                    alignItems="center"
                    textAlign="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="h4"
                      color="textSecondary"
                      component="h4"
                      gutterBottom
                    >
                      Terms and Conditions
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    f
                    alignItems="center"
                    textAlign="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="p"
                      color="primary.main"
                      sx={{ textAlign: 'center' }}
                    >
                      You have declined our terms and conditions.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    f
                    alignItems="center"
                    textAlign="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="p"
                      color="primary.main"
                      sx={{ textAlign: 'center' }}
                    >
                      Account registration has been cancelled.
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </>
        )}

        {succ > 0 && (
          <>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box mb={5} />

              <Container
                maxWidth="md"
                disableGutters
                align="center"
                sx={{
                  maxHeight: '90vh',
                  backgroundColor: 'white',
                  opacity: '0.8',
                  border: 'Solid',
                  borderWidth: '5px',
                  borderColor: 'primary.main',
                  padding: '30px',
                  borderRadius: 3,
                }}
              >
                <form>
                  <Box mb={5} />
                  <Box mb={3} />
                  <Typography
                    variant="h3"
                    color="textSecondary"
                    component="h2"
                    gutterBottom
                  >
                    Registration Complete
                  </Typography>
                  <Box mb={2} />

                  <Typography
                    variant="paragraph"
                    color="success.main"
                    component="p"
                    gutterBottom
                    fontFamily={'Arial'}
                  >
                    Your account has been created. Please login to continue with
                    your exam applications.
                  </Typography>

                  <Box mb={2} />

                  <Button variant="contained" href="../login" fullWidth>
                    Login
                  </Button>

                  <Box mb={2} />
                </form>
              </Container>
            </Box>
          </>
        )}

        {createNew > 0 && !succ && (
          <>
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box mb={5} />
              {!otpSent &&
                !isPending8 &&
                !error8 &&
                !viewTerms &&
                !enterPass && (
                  <>
                    <Container
                      maxWidth="md"
                      disableGutters
                      align="center"
                      top="50%"
                      sx={{
                        overflow: 'scroll',
                        maxHeight: '90vh',
                        backgroundColor: 'white',
                        opacity: '0.8',
                        border: 'Solid',
                        borderWidth: '5px',
                        borderColor: 'primary.main',
                        padding: '30px',
                        borderRadius: 3,
                        marginTop: 3,
                      }}
                    >
                      <form onSubmit={handleSubmit5}>
                        <Box mb={5} />

                        <Grid
                          container
                          spacing={{ xs: 2, md: 3 }}
                          columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                        >
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              f
                              alignItems="center"
                              textAlign="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="h3"
                                color="textSecondary"
                                component="h2"
                                gutterBottom
                              >
                                Register Account
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              f
                              alignItems="center"
                              textAlign="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Typography
                                variant="paragraph"
                                color="primary.main"
                                component="p"
                                gutterBottom
                                fontFamily={'Arial'}
                              >
                                Please enter candidate details below.
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              {viewEmailError && (
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{
                                      maxWidth: '95%',
                                      marginLeft: 'auto',
                                      marginRight: 'auto',
                                    }}
                                  >
                                    <TextField
                                      id="emailbox"
                                      label="Candidate Email Address/Username:"
                                      variant="outlined"
                                      type="email"
                                      required
                                      value={email}
                                      onChange={(e) => setEmail(e.target.value)}
                                      fullWidth
                                      autoComplete="email"
                                      inputProps={{
                                        style: { textAlign: 'center' },
                                      }}
                                    />
                                  </Box>
                                </Grid>
                              )}
                            </Box>
                          </Grid>

                          {!viewEmailError && (
                            <>
                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <SelectNationality
                                    nation={nation}
                                    setNation={setNation}
                                    disabled={1}
                                  />
                                </Box>
                              </Grid>

                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  {nation === 'South African' && (
                                    <TextField
                                      id="idpass"
                                      label="Candidate RSA ID/Birth Certificate Number (13 Digits)"
                                      disabled
                                      content="center"
                                      value={idpass}
                                      fullWidth
                                      required
                                      inputProps={{
                                        minLength: 13,
                                        maxLength: 13,
                                        pattern: '[0-9]+',
                                        style: { textAlign: 'center' },
                                      }}
                                      autoComplete="nope"
                                    />
                                  )}

                                  {nation !== 'South African' && (
                                    <TextField
                                      id="idpass"
                                      label="Candidate Passport Number (min 6)"
                                      disabled
                                      value={idpass}
                                      fullWidth
                                      required
                                      inputProps={{
                                        minLength: 6,
                                        maxLength: 20,
                                        style: { textAlign: 'center' },
                                      }}
                                      autoComplete="nope"
                                    />
                                  )}
                                </Box>
                              </Grid>
                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <TextField
                                    autoFocus
                                    id="fname"
                                    label="Candidate First Names"
                                    value={fname}
                                    fullWidth
                                    required
                                    onChange={(e) => setFname(e.target.value)}
                                    autoComplete="nope"
                                    inputProps={{
                                      maxLength: 100,
                                      minLength: 3,
                                      style: {
                                        textTransform: 'capitalize',
                                        textAlign: 'center',
                                      },
                                    }}
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <TextField
                                    id="lname"
                                    label="Candidate Last Name"
                                    value={lname}
                                    fullWidth
                                    required
                                    onChange={(e) => setLname(e.target.value)}
                                    autoComplete="nope"
                                    inputProps={{
                                      maxLength: 100,
                                      minLength: 3,
                                      style: {
                                        textTransform: 'capitalize',
                                        textAlign: 'center',
                                      },
                                    }}
                                  />
                                </Box>
                              </Grid>

                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <TextField
                                    id="emailbox"
                                    label="Candidate Email Address/Username:"
                                    variant="outlined"
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    fullWidth
                                    autoComplete="email"
                                    inputProps={{
                                      style: { textAlign: 'center' },
                                    }}
                                  />
                                </Box>
                              </Grid>

                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                  >
                                    <DatePicker
                                      label="Candidate DOB (YYYY/MM/DD)"
                                      inputFormat="yyyy/MM/dd"
                                      value={dob}
                                      onChange={(value) => setDob(value)}
                                      renderInput={(params) => (
                                        <TextField {...params} fullWidth />
                                      )}
                                      inputProps={{
                                        style: {
                                          textAlign: 'center',
                                          alignContent: 'center',
                                        },
                                      }}
                                      content="center"
                                    />
                                  </LocalizationProvider>
                                </Box>
                              </Grid>

                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <FormControl fullWidth>
                                    <InputLabel id="genderL">
                                      Candidate Gender*
                                    </InputLabel>

                                    <Select
                                      labelId="genderL"
                                      id="Gender"
                                      value={gender}
                                      onChange={(e) =>
                                        setGender(e.target.value)
                                      }
                                      input={<OutlinedInput label="genderL" />}
                                      required
                                    >
                                      <MenuItem value="M">Male</MenuItem>
                                      <MenuItem value="F">Female</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Box>
                              </Grid>

                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <SelectRace
                                    setRaceId={setRaceId}
                                    raceId={raceId}
                                  />
                                </Box>
                              </Grid>

                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <TextField
                                    id="saMobile"
                                    label="Candidate SA Mobile/Comms"
                                    onChange={(e) =>
                                      setSaMobile(e.target.value)
                                    }
                                    value={saMobile}
                                    fullWidth
                                    type="tel"
                                    inputProps={{
                                      maxLength: 10,
                                      minLength: 10,
                                      style: { textAlign: 'center' },
                                    }}
                                    autoComplete="nope"
                                    required
                                  />
                                </Box>
                              </Grid>

                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <SelectSALang
                                    languageId={languageId}
                                    setLanguageId={setLanguageId}
                                    label="Home Language"
                                  />
                                </Box>
                              </Grid>

                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <TextField
                                    id="school"
                                    label="Current School/Education Provider:"
                                    value={school}
                                    fullWidth
                                    required
                                    onChange={(e) => setSchool(e.target.value)}
                                    autoComplete="nope"
                                    inputProps={{
                                      maxLength: 100,
                                      minLength: 3,
                                      style: {
                                        textTransform: 'capitalize',
                                        textAlign: 'center',
                                      },
                                    }}
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <SelectPreviousGrade
                                    prevGrade={grade}
                                    setPrevGrade={setGrade}
                                  />
                                </Box>
                              </Grid>
                            </>
                          )}

                          {error7 && !errorMessage7 && (
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <p className="error">
                                  Service currently offline. Please try again
                                  later.
                                </p>
                              </Box>
                            </Grid>
                          )}
                          {errorMessage7 && (
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <p className="error">{errorMessage7}</p>
                              </Box>
                            </Grid>
                          )}

                          {dob && !isPending7 && (
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{
                                      maxWidth: '95%',
                                      marginLeft: 'auto',
                                      marginRight: 'auto',
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      type="submit"
                                      fullWidth
                                    >
                                      Continue
                                    </Button>
                                  </Box>
                                </Grid>
                              </Box>
                            </Grid>
                          )}

                          {!dob && !isPending7 && (
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{
                                      maxWidth: '95%',
                                      marginLeft: 'auto',
                                      marginRight: 'auto',
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      disabled
                                      fullWidth
                                    >
                                      Continue
                                    </Button>
                                  </Box>
                                </Grid>
                              </Box>
                            </Grid>
                          )}

                          {isPending7 && (
                            <Grid item xs={12}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button variant="contained" disabled fullWidth>
                                  <CircularProgress />
                                </Button>
                              </Box>
                            </Grid>
                          )}

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Link href="../login">Login</Link>
                            </Box>
                          </Grid>

                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Link href="../forgotpassword">
                                Forgot Password?
                              </Link>
                            </Box>
                          </Grid>
                        </Grid>
                      </form>
                    </Container>
                  </>
                )}

              {isPending8 && (
                <>
                  <Container
                    maxWidth="xs"
                    disableGutters
                    align="center"
                    top="50%"
                    sx={{
                      backgroundColor: 'white',
                      opacity: '0.8',
                      border: 'Solid',
                      borderWidth: '5px',
                      borderColor: 'primary.main',
                      padding: '30px',
                      borderRadius: 3,
                      marginTop: 3,
                    }}
                  >
                    <Grid
                      container
                      spacing={{ xs: 2, md: 3 }}
                      columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                    >
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="h5"
                            color="textSecondary"
                            component="h5"
                            gutterBottom
                          >
                            Sending OTP
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Button variant="contained" disabled fullWidth>
                            <CircularProgress />
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Container>
                </>
              )}

              {error8 && (
                <>
                  <form onSubmit={resendNewOTP}>
                    <Container
                      maxWidth="sm"
                      disableGutters
                      align="center"
                      top="50%"
                      sx={{
                        backgroundColor: 'white',
                        opacity: '0.8',
                        border: 'Solid',
                        borderWidth: '5px',
                        borderColor: 'primary.main',
                        padding: '30px',
                        borderRadius: 3,
                        marginTop: 3,
                      }}
                    >
                      <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                      >
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <p className="error">
                              An error occurred when emailing your OTP. Please
                              click retry or send an email with your details to{' '}
                              <a href="mailto:privatecandidates@bicollege.co.za">
                                privatecandidates@bicollege.co.za
                              </a>{' '}
                              to request further assistance.{' '}
                            </p>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button
                                  variant="contained"
                                  type="submit"
                                  fullWidth
                                >
                                  Resend OTP
                                </Button>
                              </Box>
                            </Grid>
                          </Box>
                        </Grid>
                      </Grid>
                      <Box mb={5} />
                    </Container>
                  </form>
                </>
              )}
              {otpSent > 0 && !enterPass && !isPending8 && (
                <Container
                  maxWidth="md"
                  disableGutters
                  align="center"
                  top="50%"
                  sx={{
                    backgroundColor: 'white',
                    opacity: '0.8',
                    border: 'Solid',
                    borderWidth: '5px',
                    borderColor: 'primary.main',
                    padding: '30px',
                    borderRadius: 3,
                    marginTop: 3,
                  }}
                >
                  <form onSubmit={handleSubmit6}>
                    <Grid
                      container
                      spacing={{ xs: 2, md: 3 }}
                      columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                    >
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="h4"
                            color="textSecondary"
                            component="h4"
                            gutterBottom
                          >
                            Register Account
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="h5"
                            color="textSecondary"
                            component="h5"
                            gutterBottom
                          >
                            Verification
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="paragraph"
                            color="textSecondary"
                            component="p"
                            gutterBottom
                            fontFamily={'Arial'}
                          >
                            An OTP has been sent to {email}.
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Typography
                            variant="paragraph"
                            color="textSecondary"
                            component="p"
                            gutterBottom
                            fontFamily={'Arial'}
                          >
                            Please enter the OTP below to verify your account.
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          sx={{
                            maxWidth: '95%',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                          }}
                        >
                          <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <TextField
                                id="otp"
                                label="Enter OTP:"
                                variant="outlined"
                                type="numbers"
                                required
                                onChange={(e) => setOTP(e.target.value)}
                                value={otp}
                                fullWidth
                                autoFocus
                                inputProps={{ style: { textAlign: 'center' } }}
                              />
                            </Box>
                          </Grid>
                        </Box>
                      </Grid>

                      {error9 && !errorMessage9 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <p className="error">
                              Service currently offline. Please try again later.
                            </p>
                          </Box>
                        </Grid>
                      )}
                      {errorMessage9 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <p className="error">{errorMessage9}</p>
                          </Box>
                        </Grid>
                      )}

                      {!isPending9 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button
                                  fullWidth
                                  variant="contained"
                                  type="submit"
                                >
                                  Submit OTP
                                </Button>
                              </Box>
                            </Grid>
                          </Box>
                        </Grid>
                      )}

                      {isPending9 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Button variant="contained" disabled fullWidth>
                              <CircularProgress />
                            </Button>
                          </Box>
                        </Grid>
                      )}

                      {!resend && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              OR
                            </Typography>
                          </Box>
                        </Grid>
                      )}

                      {(!isPending8 || !isPending8) && !resend && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                  maxWidth: '95%',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                }}
                              >
                                <Button
                                  variant="contained"
                                  onClick={(e) => resendNewOTP2()}
                                  fullWidth
                                >
                                  Resend OTP
                                </Button>
                              </Box>
                            </Grid>
                          </Box>
                        </Grid>
                      )}
                      {resend === 1 && (
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              OTP resent via email to {email}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  </form>
                </Container>
              )}

              {viewTerms === 1 && (
                <>
                  <Container
                    maxWidth="md"
                    disableGutters
                    align="center"
                    top="50%"
                    sx={{
                      height: '90vh',
                      overflow: 'scroll',
                      backgroundColor: 'white',
                      opacity: '0.8',
                      border: 'Solid',
                      borderWidth: '5px',
                      borderColor: 'primary.main',
                      padding: '30px',
                      borderRadius: 3,
                      marginTop: 3,
                    }}
                  >
                    <form onSubmit={handleSubmit7}>
                      <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                      >
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h4"
                              color="textSecondary"
                              component="h4"
                              gutterBottom
                            >
                              Terms and Conditions
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="textSecondary"
                              component="h5"
                              gutterBottom
                            >
                              Agreement 1:
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              To view our Terms and Conditions, visit:
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              <a
                                href="https://privatecandidate.bi-oss.co.za/tnc"
                                target="blank"
                              >
                                https://privatecandidate.bi-oss.co.za/tnc
                              </a>
                              .
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              By clicking agree, I state that I have read,
                              understood and agree to all the "Terms and
                              Conditions" in the above link.
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={12}
                              sx={{
                                textAlign: 'center',
                                alignContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Typography
                                color="primary.main"
                                sx={{ textAlign: 'left' }}
                              >
                                I <u>Decline</u>{' '}
                              </Typography>
                              {conf1 === false && (
                                <>
                                  <Switch
                                    checked={false}
                                    required
                                    inputProps={{ 'aria-label': 'ant design' }}
                                    onChange={(e) => setConf1(true)}
                                    name="I Decline"
                                  />
                                </>
                              )}
                              {conf1 === true && (
                                <>
                                  <Switch
                                    sx={{ textAlign: 'center' }}
                                    color="success"
                                    checked={true}
                                    required
                                    inputProps={{ 'aria-label': 'ant design' }}
                                    onChange={(e) => setConf1(false)}
                                    name="I Agree"
                                  />
                                </>
                              )}

                              <Typography
                                color="primary.main"
                                sx={{ textAlign: 'right' }}
                              >
                                I <u>Agree</u>{' '}
                              </Typography>
                            </Stack>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Divider
                              style={{ width: '100%', color: 'primary.main' }}
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="textSecondary"
                              component="h5"
                              gutterBottom
                            >
                              Agreement 2:
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              To view the Code of Conduct visit:
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              <a
                                href="https://privatecandidate.bi-oss.co.za/conduct"
                                target="blank"
                              >
                                https://privatecandidate.bi-oss.co.za/conduct
                              </a>
                              .
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              By clicking agree, I state that I have read,
                              understood and agree to the "Code of Conduct" in
                              the above link.
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={12}
                              sx={{
                                textAlign: 'center',
                                alignContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Typography
                                color="primary.main"
                                sx={{ textAlign: 'left' }}
                              >
                                I <u>Decline</u>{' '}
                              </Typography>
                              {conf2 === false && (
                                <>
                                  <Switch
                                    checked={false}
                                    required
                                    inputProps={{ 'aria-label': 'ant design' }}
                                    onChange={(e) => setConf2(true)}
                                    name="I Decline"
                                  />
                                </>
                              )}
                              {conf2 === true && (
                                <>
                                  <Switch
                                    sx={{ textAlign: 'center' }}
                                    color="success"
                                    checked={true}
                                    required
                                    inputProps={{ 'aria-label': 'ant design' }}
                                    onChange={(e) => setConf2(false)}
                                    name="I Agree"
                                  />
                                </>
                              )}

                              <Typography
                                color="primary.main"
                                sx={{ textAlign: 'right' }}
                              >
                                I <u>Agree</u>{' '}
                              </Typography>
                            </Stack>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Divider
                              style={{ width: '100%', color: 'primary.main' }}
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="textSecondary"
                              component="h5"
                              gutterBottom
                            >
                              Agreement 3:
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              To view the Cambridge International Examination
                              Rules and Regulations:
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              <a
                                href="https://privatecandidate.bi-oss.co.za/cierules"
                                target="blank"
                              >
                                https://privatecandidate.bi-oss.co.za/cierules
                              </a>
                              .
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="body2"
                              component="p"
                              color="primary.main"
                              sx={{ textAlign: 'center' }}
                            >
                              By clicking agree, I state that I have read,
                              understood and agree to all the "Cambridge
                              International Examination Rules and Regulations"
                              in the above link.
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={12}
                              sx={{
                                textAlign: 'center',
                                alignContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Typography
                                color="primary.main"
                                sx={{ textAlign: 'left' }}
                              >
                                I <u>Decline</u>{' '}
                              </Typography>
                              {conf3 === false && (
                                <>
                                  <Switch
                                    checked={false}
                                    required
                                    inputProps={{ 'aria-label': 'ant design' }}
                                    onChange={(e) => setConf3(true)}
                                    name="I Decline"
                                  />
                                </>
                              )}
                              {conf3 === true && (
                                <>
                                  <Switch
                                    sx={{ textAlign: 'center' }}
                                    color="success"
                                    checked={true}
                                    required
                                    inputProps={{ 'aria-label': 'ant design' }}
                                    onChange={(e) => setConf3(false)}
                                    name="I Agree"
                                  />
                                </>
                              )}

                              <Typography
                                color="primary.main"
                                sx={{ textAlign: 'right' }}
                              >
                                I <u>Agree</u>{' '}
                              </Typography>
                            </Stack>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Divider
                              style={{ width: '100%', color: 'primary.main' }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography sx={{ textAlign: 'center' }}>
                              *{' '}
                              <i>
                                <b>Please Note: </b>The above "Cambridge
                                International Examination Rules and
                                Regulations", "Code of Conduct", "Terms and
                                Conditions" are all subject to change.
                              </i>{' '}
                            </Typography>
                          </Box>
                        </Grid>

                        {error10 && !errorMessage10 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <p className="error">
                                Service currently offline. Please try again
                                later.
                              </p>
                            </Box>
                          </Grid>
                        )}
                        {errorMessage10 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <p className="error">{errorMessage10}</p>
                            </Box>
                          </Grid>
                        )}

                        {!isPending10 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    type="submit"
                                    fullWidth
                                  >
                                    Accept
                                  </Button>
                                </Box>
                              </Grid>
                            </Box>
                          </Grid>
                        )}

                        {isPending10 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button variant="contained" disabled fullWidth>
                                <CircularProgress />
                              </Button>
                            </Box>
                          </Grid>
                        )}
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="textSecondary"
                              component="h5"
                              gutterBottom
                            >
                              OR
                            </Typography>
                          </Box>
                        </Grid>
                        {!isPending10 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    onClick={(e) => handleDecline()}
                                    fullWidth
                                  >
                                    Decline
                                  </Button>
                                </Box>
                              </Grid>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </form>
                  </Container>
                </>
              )}

              {enterPass > 0 && (
                <>
                  <Box mb={5} />
                  <Container
                    maxWidth="xs"
                    disableGutters
                    align="center"
                    top="50%"
                    sx={{
                      backgroundColor: 'white',
                      opacity: '0.8',
                      border: 'Solid',
                      borderWidth: '5px',
                      borderColor: 'primary.main',
                      padding: '30px',
                      borderRadius: 3,
                      marginTop: 3,
                    }}
                  >
                    <form onSubmit={handleSubmit8}>
                      <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                      >
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="textSecondary"
                              component="h5"
                              gutterBottom
                            >
                              Create Account
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              Please enter a password for your account.
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                            >
                              Password minimum requirements:
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <Typography
                              variant="paragraph"
                              color="textSecondary"
                              component="p"
                              gutterBottom
                              fontFamily={'Arial'}
                              textAlign="left"
                            >
                              <ul>
                                <li>Minimum of 8 character</li>
                                <li>1 Uppercase character</li>
                                <li>1 Lowercase character</li>
                                <li>1 Numeric Character (Number)</li>
                                <li>1 Symbol (special character )</li>
                              </ul>
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              maxWidth: '95%',
                              marginLeft: 'auto',
                              marginRight: 'auto',
                            }}
                          >
                            <TextField
                              id="password"
                              label="New Password"
                              onChange={(e) => validate(e.target.value)}
                              fullWidth
                              required
                              type="password"
                              autoComplete="nope"
                              inputProps={{
                                maxLength: 100,
                                minLength: 8,
                                style: { textAlign: 'center' },
                              }}
                            />
                          </Box>
                        </Grid>

                        {errorPass && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <p className="error">{errorPass}</p>
                            </Box>
                          </Grid>
                        )}
                        {successPass && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <TextField
                                id="Notification"
                                InputProps={{
                                  readOnly: true,
                                }}
                                value={successPass}
                                fullWidth
                                required
                                sx={{
                                  borderRadius: 1,
                                  backgroundColor: 'success.main',
                                  input: {
                                    color: 'white',
                                    textAlign: 'center',
                                  },
                                }}
                              />
                            </Box>
                          </Grid>
                        )}

                        {error11 && !errorMessage11 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <p className="error">
                                Service currently offline. Please try again
                                later.
                              </p>
                            </Box>
                          </Grid>
                        )}
                        {errorMessage11 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <p className="error">{errorMessage11}</p>
                            </Box>
                          </Grid>
                        )}

                        {!isPending11 && !errorPass && password && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button
                                variant="contained"
                                type="submit"
                                fullWidth
                              >
                                Create Account
                              </Button>
                            </Box>
                          </Grid>
                        )}
                        {(errorPass || !password) && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button variant="contained" disabled fullWidth>
                                Create Account
                              </Button>
                            </Box>
                          </Grid>
                        )}
                        {isPending11 && (
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              sx={{
                                maxWidth: '95%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                              }}
                            >
                              <Button variant="contained" disabled fullWidth>
                                <CircularProgress />
                              </Button>
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </form>
                  </Container>
                </>
              )}
            </Box>
          </>
        )}
      </ProductHeroLayout>
    </>
  );
}
